import { render, staticRenderFns } from "./container.vue?vue&type=template&id=cb236124&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"
import style0 from "./container.vue?vue&type=style&index=0&id=cb236124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb236124",
  null
  
)

export default component.exports